export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/theme/components/scorecard/ScorecardView/ScorecardExport.js